.bj{position:absolute;}